var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/viewattachments',["require", "exports", "plugins/dialog", "common/viewmodelbase", "areas/informationrequest/models/bindable", "areas/informationrequest/service/informationrequest-service", "services/settings", "models/account", "areas/informationrequest/service/toastDCService"], function (require, exports, dialog, common, VM, service, settings, Account, toastService) {
    "use strict";
    var ViewAttachmentsViewModel = (function (_super) {
        __extends(ViewAttachmentsViewModel, _super);
        function ViewAttachmentsViewModel() {
            _super.call(this);
            this.attachments = new Array();
            this.selectedAttachments = ko.observableArray([]);
            this.files = new Array();
            this.newAttachments = new Array();
            this.informationrequestService = new service.InformationRequestService();
            this.toastDCService = new toastService.ToastDCService();
            ko.track(this, ["attachments", "files", "newAttachments"]);
        }
        ViewAttachmentsViewModel.prototype.onActivated = function (context) {
            var self = this;
            var parent = context.callingParameters.get("unknown");
            var sectionGuid = parent.selectedSection.sectionGuid;
            self.advisorName = Account.Principal.current.identityName;
            self.organizationID = parent.activeOrganization.organizationId;
            self.attachments.removeAll();
            self.newAttachments.removeAll();
            self.files.removeAll();
            self.displayAttachments(parent, sectionGuid);
            self.onFileSelectedEvent = function (vm, evt) {
                ko.utils.arrayForEach(evt.target.files, function (file) {
                    self.informationrequestService.uploadAttachment(file, parent.clientGuid, parent.taxYear, sectionGuid, 1, 0).then(function (response) {
                        if (response.statusCode == 400 && response.reasonPhrase == "Bad Request") {
                            self.toastDCService.constructDCToast('fail', "Upload failed. Unsupported File Extension.");
                        }
                        else if (response.statusCode == 406 && response.reasonPhrase == "Not Acceptable") {
                            self.toastDCService.constructDCToast('info', "Our systems has detected that file(s) are harmful and have not been uploaded. Please check and reattach.");
                        }
                        else if (response.statusCode == 200 && response.reasonPhrase == "OK") {
                            self.toastDCService.constructDCToast('success', "File uploaded.");
                        }
                        else if (response.statusCode == 500 && response.reasonPhrase == "Internal Server Error") {
                            self.toastDCService.constructDCToast('fail', "File upload failed.");
                        }
                        else {
                            self.toastDCService.constructDCToast('info', JSON.stringify(response));
                        }
                        console.log(JSON.stringify(response));
                        self.displayAttachments(parent, sectionGuid);
                    }).fail(function (reason) {
                        if (reason.status == 406 && reason.statusText == "Not Acceptable") {
                            self.toastDCService.constructDCToast('info', "Our systems has detected that file(s) are harmful and have not been uploaded. Please check and reattach.");
                        }
                        else {
                            self.toastDCService.constructDCToast('fail', "We were unable to upload your file. Your data remains unchanged.");
                        }
                    });
                });
            };
            this.deleteAttachment = function () {
                var _this = this;
                for (var i = 0; i < self.attachments.length; i++) {
                    if (self.attachments[i].shouldDelete) {
                        self.informationrequestService.deleteAttachment(self.attachments[i].attachmentGuid, parent.taxYear, parent.clientGuid, self.attachments[i].fullName, sectionGuid).then(function (response) {
                            self.displayAttachments(parent, sectionGuid);
                            $("#dialogDeleteAttachmentId").modal("hide");
                        }).fail(function (reason) {
                            _this.toastDCService.constructDCToast('info', reason.toString());
                        });
                    }
                }
            };
        };
        ViewAttachmentsViewModel.prototype.DoSomething = function (self, newSelectedFilters) {
        };
        ViewAttachmentsViewModel.prototype.closeDialog = function () {
            dialog.close(this);
        };
        ViewAttachmentsViewModel.prototype.closeDeleteDialog = function () {
            for (var i = 0; i < this.attachments.length; i++) {
                this.attachments[i].shouldDelete = false;
            }
            $("#dialogDeleteAttachmentId").modal("hide");
        };
        ViewAttachmentsViewModel.prototype.showDeleteDialog = function (attachment) {
            attachment.shouldDelete = true;
            ;
            $("#dialogDeleteAttachmentId").modal("show");
        };
        ViewAttachmentsViewModel.prototype.displayAttachments = function (parent, sectionGuid) {
            var _this = this;
            var self = this;
            self.informationrequestService.getAttachment(sectionGuid).then(function (response) {
                self.files.removeAll();
                self.attachments.removeAll();
                for (var i = 0; i < response.length; i++) {
                    var attachment = response[i];
                    self.files.push(attachment);
                }
                parent.selectedSection.attachmentsCount(self.files.length);
                for (var i = 0; i < self.files.length; i++) {
                    var item = new VM.Attachment;
                    item.attachmentGuid = self.files[i].attachmentGuid;
                    item.shouldDelete = false;
                    if (self.files[i].displayName.length > 25) {
                        item.displayName = self.files[i].displayName.slice(0, 22) + "...";
                        item.fullName = self.files[i].displayName;
                    }
                    else {
                        item.displayName = self.files[i].displayName;
                        item.fullName = self.files[i].displayName;
                    }
                    if (self.files[i].userName != null) {
                        if (self.files[i].userName.length > 27) {
                            item.displayUserName = self.files[i].userName.slice(0, 24) + "...";
                            item.userName = self.files[i].userName;
                        }
                        else {
                            item.displayUserName = self.files[i].userName;
                            item.userName = self.files[i].userName;
                        }
                    }
                    if (self.files[i].dateAdded != null) {
                        var date = new Date(self.files[i].dateAdded);
                        item.dateAdded = date.toLocaleString("en-GB");
                    }
                    if (item.userName == self.advisorName)
                        item.deleteAttachmentVisible = true;
                    else
                        item.deleteAttachmentVisible = false;
                    var baseUrl = settings.Settings.environment.getCustomValue("CCHDataCollection");
                    item.path = baseUrl + "api/download/Get/DataCollection/" + parent.clientGuid + "/" + sectionGuid + "/" + item.fullName + "/" + self.organizationID;
                    _this.attachments.push(item);
                }
                if (_this.selectedAttachments().length != 0)
                    _this.selectedAttachments.removeAll();
                _this.selectedAttachments.subscribe(function (newSelectedFilters) {
                    self.DoSomething(self, newSelectedFilters);
                });
            });
        };
        return ViewAttachmentsViewModel;
    }(common.ListViewModelBase));
    var instance = new ViewAttachmentsViewModel();
    return instance;
});

